/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { parseDate, currency } from '@global/helpers';
import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import TableMobile from '@components/table/TableMobile';
import ModalHalf from '@components/modal/ModalHalf';
import ItemDetail from '@components/global/ItemDetail';
import SociollaText from '@components/sociolla/SociollaText';
import StatusBadge from '@components/global/StatusBadge';
import SelectBox from '@components/form/SelectBox';
import MoreButton from '@components/navbar/MoreButton';

import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';

import store from '@/store';
import { filterAdded, paramsReseted } from '@/store/params';

const tableStructure = {
  name: {
    head: 'Invoice Number',
    body: 'name',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  invoice_date: {
    head: 'Invoice Date',
    body: 'invoice_date',
    type: 'date',
  },
  journal_date: {
    head: 'Journal Date',
    body: 'journal_date',
    type: 'date',
  },
  source_document: {
    head: 'Source Document',
    body: 'source_document',
  },
  total: {
    head: 'Total Value',
    body: 'total',
    type: 'currency',
  },
  status: {
    head: 'Status',
    type: 'status',
    body: 'status',
  },
};

const INVOICE_STATUS = [
  { name: 'All', value: '' },
  { name: 'Paid', value: 'paid' },
  { name: 'Not Paid', value: 'not_paid' },
];

const ReturnOrderInvoiceScreen = (props) => {
  const dispatch = useDispatch();
  const paramsState = useSelector((state) => state.params);

  const [loading, setLoading] = useState(false);
  const [loadingPagination, setLoadingPagination] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [total, setTotal] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const isOrder = props?.route?.params?.salesOrderId ? true : false;
  const isCustomer = props?.route?.params?.customerId ? true : false;

  const getInvoiceDelivery = async (newSkip = 0) => {
    const isLoadMore = newSkip > 0;
    if (isLoadMore) {
      setLoadingPagination(true);
    } else {
      setLoading(true);
    }
    try {
      if (isOrder) {
        const response = await MsOrder.getSalesOrderInvoiceDelivery(
          props.route.params.salesOrderId,
        );
        if (response?.data?.data?._id) {
          const data = response.data.data;
          const result = data?.invoices?.length ? data.invoices : [];
          setTotal(result.length);
          setTableData(result);
        }
      } else if (isCustomer) {
        const customerId = props.route.params.customerId;
        const params = {
          params: JSON.parse(JSON.stringify(store.getState().params)),
        };
        params.params.filter.is_detail_invoice = true;

        const responseCustomer = await MsAccount.getCustomerInvoice(
          customerId,
          params,
        );
        if (responseCustomer?.data?.data) {
          const resultCustomer = responseCustomer?.data?.data;
          setTableData(resultCustomer);
          if (responseCustomer?.data?.count) {
            setTotal(responseCustomer.data.count);
          }
          if (responseCustomer?.data?.sub_total) {
            setSubTotal(responseCustomer.data.sub_total);
          }
        }
      }
      if (isLoadMore) {
        setLoadingPagination(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      if (isLoadMore) {
        setLoadingPagination(false);
      } else {
        setLoading(false);
      }
    }
  };

  const onChangeFilter = (val) => {
    if (val) {
      if (val.value) {
        dispatch(
          filterAdded({
            ...paramsState.filter,
            status: val.value,
          }),
        );
      } else {
        const old_filter = JSON.parse(JSON.stringify(paramsState.filter));
        delete old_filter.status;
        dispatch(filterAdded(old_filter));
      }
      setSelectedFilter(val);
      getInvoiceDelivery();
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (isCustomer) {
        if (!isWeb) {
          props.navigation.setOptions({
            headerRight: () => (
              <MoreButton
                menu={INVOICE_STATUS.map((item) => {
                  return {
                    type: 'function',
                    name: item.name,
                    callback: () => onChangeFilter(item),
                  };
                })}
                {...props}
              />
            ),
          });
        }
        dispatch(paramsReseted());
        dispatch(
          filterAdded({
            ...paramsState.filter,
            status: INVOICE_STATUS[2].value,
          }),
        );
        setSelectedFilter(INVOICE_STATUS[2]);
      } else {
        setSelectedFilter(null);
      }
      setDetailData({});
      setTotal(0);
      setSubTotal(0);
      setTableData([]);
      getInvoiceDelivery();
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {isWeb ? (
        <>
          <Layout.Back
            title={
              isCustomer
                ? props.route.params.titleScreen
                : props.route.params?.reference || ''
            }
            onCallback={() => {
              if (isCustomer) {
                props.navigation.replace('SalesOrderInvoiceScreen', {
                  customerId: '',
                });
                props.navigation.navigate('CustomerNavigator', {
                  screen: 'CustomerDetailScreen',
                  params: {
                    id: props.route.params.customerId,
                    name: props.route.params.titleScreen,
                  },
                });
              } else {
                props.navigation.navigate(
                  'SalesOrderDetailScreen',
                  props.route.params,
                );
              }
            }}
          />
          <Layout.Title
            title={`Invoices ${total}`}
            style={isWeb ? { zIndex: 100 } : {}}>
            {isWeb && isCustomer ? (
              <View>
                <SelectBox
                  label="Status"
                  hideLabel
                  isDropdown
                  options={INVOICE_STATUS}
                  value={selectedFilter}
                  placeholder="Select Status"
                  trackBy="value"
                  labelKey="name"
                  onChange={(val) => {
                    onChangeFilter(val);
                  }}
                />
              </View>
            ) : (
              false
            )}
          </Layout.Title>
          <Table
            name="sales-order-invoice"
            structures={tableStructure}
            data={tableData}
            totalData={total}
            loading={loading}
            showSearch={false}
            showFilter={false}
            hasCallback
            hasNoHide
            showResetFilter={isCustomer}
            bottomPaginationOnly
            showPagination={isCustomer}
            skip={paramsState.skip}
            limit={paramsState.limit}
            subTotal={subTotal}
            onClickRow={({ data }) => {
              setShowDetail(true);
              setDetailData(data);
            }}
            onSearch={() => getInvoiceDelivery()}
          />
        </>
      ) : (
        <TableMobile
          name="sales-order-invoice"
          loading={loading}
          onSearch={() => getInvoiceDelivery()}
          showSearch={false}
          skip={paramsState.skip}
          limit={paramsState.limit}
          tableData={tableData}
          totalData={total}
          loadingPagination={loadingPagination}
          withLoadMore={isCustomer}
          withFetch={isCustomer}
          onLoadMore={(val) => getInvoiceDelivery(val)}
          footerComponent={true}
          renderItem={({ data, index }) => (
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.orderItem}
              key={index}
              onPress={() => {
                setShowDetail(true);
                setDetailData(data);
              }}>
              <View style={styles.orderItemSection}>
                <View style={[styles.itemText, { width: 120 }]}>
                  <SociollaText style={styles.itemTextOne}>
                    Invoice Number:
                  </SociollaText>
                  <SociollaText type="medium" style={styles.itemTextTwo}>
                    {data.name ? data.name : '-'}
                  </SociollaText>
                </View>
                <View style={styles.itemText}>
                  <SociollaText style={styles.itemTextOne}>
                    Amount Due:
                  </SociollaText>
                  <SociollaText
                    type="medium"
                    style={[styles.itemTextTwo, { color: Colors.blue1 }]}>
                    {data.total ? currency(data.total, true) : '-'}
                  </SociollaText>
                </View>
                <StatusBadge status={data.status} />
              </View>
            </TouchableOpacity>
          )}
        />
      )}

      {!isWeb ? (
        <Layout.ButtonSticky
          show={props?.route?.name == 'SalesOrderInvoiceScreen'}
          route={props?.route}
          buttons={[
            {
              component: (
                <View style={styles.footerMobile}>
                  <SociollaText type="medium">Subtotal</SociollaText>
                  <SociollaText type="bold" style={styles.textSubtotal}>
                    {currency(subTotal, true)}
                  </SociollaText>
                </View>
              ),
            },
          ]}
        />
      ) : (
        false
      )}

      <ModalHalf
        title={detailData.name}
        visible={showDetail}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() => {
          setShowDetail(false);
          setDetailData({});
        }}
        children={
          <ScrollView
            contentContainerStyle={{ width: '100%', paddingHorizontal: 15 }}>
            <ItemDetail
              name="Journal Date"
              value={
                detailData.journal_date
                  ? parseDate(detailData.journal_date)
                  : '-'
              }
            />
            <ItemDetail
              name="Invoice Date"
              value={
                detailData.invoice_date
                  ? parseDate(detailData.invoice_date)
                  : '-'
              }
            />
            {/* <ItemDetail
							name="Due Date"
							value={detailData.due_date}
						/> */}
            {/* <ItemDetail
							name="Tax Exclude"
							value={detailData.tax}
						/> */}
            <ItemDetail
              name="Total"
              value={detailData.total ? currency(detailData.total, true) : '-'}
              valueBold={true}
              valueStyle={{ color: Colors.blue1 }}
            />
            <ItemDetail
              name="Invoice Status"
              centered
              value={<StatusBadge status={detailData.status} />}
            />
            {/* <ItemDetail
							name="Payment Status"
							centered
							withoutBorder={true}
							value={<StatusBadge status={detailData.payment} />}
						/> */}
          </ScrollView>
        }
      />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  orderItem: {
    width: '100%',
    paddingVertical: 20,
    paddingHorizontal: 10,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  orderItemSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  itemText: {
    marginRight: 10,
  },
  itemTextOne: {
    fontSize: 12,
    marginBottom: 5,
  },
  itemTextTwo: {
    fontSize: 14,
  },
  footerMobile: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textSubtotal: { color: Colors.blue1 },
});

export default ReturnOrderInvoiceScreen;
